<div class="license-image-card" [class.uploaded]="isUploaded" [class.disabled]="disabled" (click)="onCardClick($event)">
  <!-- Image Label - Red when not uploaded -->
  <div class="image-label" [class.required]="!isUploaded">
    {{ imageType === 'front' ? 'Front' : 'Back' }}
  </div>

  <!-- Card Body - No header, no labels -->
  <div class="card-body">
    @if (isUploaded && imageUrl) {
      <!-- Uploaded Image Preview -->
      <div class="image-preview">
        <img [src]="imageUrl" [alt]="displayLabel" />
        <div class="image-overlay">
          <mat-icon class="zoom-icon">zoom_in</mat-icon>
        </div>
      </div>
    } @else {
      <!-- Empty State -->
      <div class="empty-state">
        <mat-icon class="upload-icon">add_photo_alternate</mat-icon>
        <span class="upload-text">{{ imageType === 'front' ? 'Upload Front Image' : 'Upload Back Image' }}</span>
      </div>
    }
  </div>

  <!-- Card Footer - Minimal -->
  <div class="card-footer" (click)="$event.stopPropagation()">
    @if (isUploaded) {
      <!-- Replace Icon (Upload) -->
      <button 
        mat-icon-button 
        class="action-button"
        (click)="handleReplaceClick($event)"
        [disabled]="disabled"
        matTooltip="Replace"
      >
        <mat-icon>cloud_upload</mat-icon>
      </button>
      <!-- View Icon (Eye) -->
      <button 
        mat-icon-button 
        class="action-button"
        (click)="handleViewClick($event)"
        [disabled]="disabled"
        matTooltip="View"
      >
        <mat-icon>visibility</mat-icon>
      </button>
    } @else {
      <button 
        mat-icon-button
        class="action-button"
        (click)="handleUploadClick()"
        [disabled]="disabled"
        matTooltip="Upload"
      >
        <mat-icon>cloud_upload</mat-icon>
      </button>
    }
  </div>
</div>

